<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <div class="row mt-2">
                <div class="col-md-12">
                  <button
                    type="submit"
                    @click="handleForm"
                    class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3"
                  >
                    <i class="material-symbols-outlined">check</i>
                    Simpan Kamar
                  </button>
                  <!-- <router-link
                    class="btn btn-outline-danger btn-no-outline float-right"
                    to="/master/kamar"
                    >Batalkan</router-link
                  > -->
                  <a
                    class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                    @click="() => goBack('/master/kamar')"
                    >Batalkan
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
// import { HTTP } from "@/config.js";
let data = {
  title: "Kamar Baru",
  backBtn: "/master/kamar",
  actionBtn: [],
  breadcrumb: [
    { title: "Kamar", link: "/master/kamar" },
    { title: "Baru", active: true },
  ],
};

export default {
  name: "KamarForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      leftForm: [
        {
          colnum: 2,
          columns: [
            {
              name: "kelas",
              type: "select",
              label: "Pilih Kelas",
              options: [
                {
                  value: "VIP",
                  label: "Kelas VIP",
                },
                {
                  value: "I",
                  label: "Kelas I",
                },
                {
                  value: "II",
                  label: "Kelas II",
                },
                {
                  value: "III",
                  label: "Kelas III",
                },
              ],
              colwidth: 5,
            },
            { name: "nama", type: "text", label: "Nama Kamar", colwidth: 7 },
          ],
        },
        {
          colnum: 2,
          columns: [
            {
              name: "number",
              type: "number",
              label: "Jumlah Bangsal",
              colwidth: 5,
            },
            { name: "biaya", type: "money", label: "Biaya/Malam", colwidth: 7 },
          ],
        },
      ],
      formSet: {
        kelas: "",
        nama: "",
        number: 1,
        biaya: 0,
        status: "KOSONG",
      },
    };
  },
  methods: {
    goBack(url) {
      if (window.history.length <= 1) {
        this.$router.push({ path: url });
      } else {
        this.$router.go(-1);
      }
    },
    handleForm: async function() {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (key != "number") {
            formData.append(key, self.formSet[key]);
          }
        });
        for (var i = 0; i < parseInt(this.formSet.number); i++) {
          //console.log(i+1);
          let submit = formData;
          submit.append("no_kasur", i + 1);
          try {
            let result = await this.$store.state.HTTP.post(
              "ranap/fasilitas/kamar",
              submit
            );
            if (result.status != "200") {
              this.errors.push(result.status);
              return;
            }
          } catch (e) {
            //console.log(e);
            this.errors.push(e);
            return;
          }
          if (i == parseInt(this.formSet.number) - 1) {
            this.$router.push(`/master/kamar`);
          }
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      return valid;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {},
};
</script>
